import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import axios from "axios";
import { API_BASE, formatApiError } from "./AuthContext";

const PortalCtx = createContext(null);

export function PortalAuthProvider({ children }) {
  const [state, setState] = useState(null); // null = loading, false = unauth, object = authed

  const refresh = useCallback(async () => {
    try {
      const { data } = await axios.get(`${API_BASE}/portal/me`);
      setState(data);
    } catch {
      setState(false);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const login = useCallback(async (email, password) => {
    const r = await axios.post(`${API_BASE}/portal/auth/login`, { email, password });
    await refresh();
    return r.data;
  }, [refresh]);

  const consumeMagic = useCallback(async (token) => {
    const r = await axios.post(`${API_BASE}/portal/auth/magic/${token}`);
    await refresh();
    return r.data;
  }, [refresh]);

  const setPassword = useCallback(async (password) => {
    await axios.post(`${API_BASE}/portal/auth/set-password`, { password });
    await refresh();
  }, [refresh]);

  const logout = useCallback(async () => {
    try { await axios.post(`${API_BASE}/portal/auth/logout`); }
    catch (err) { console.error("portal logout failed", err); }
    setState(false);
  }, []);

  const value = useMemo(
    () => ({ state, login, consumeMagic, setPassword, logout, refresh, formatApiError }),
    [state, login, consumeMagic, setPassword, logout, refresh]
  );

  return <PortalCtx.Provider value={value}>{children}</PortalCtx.Provider>;
}

export function usePortalAuth() {
  const ctx = useContext(PortalCtx);
  if (!ctx) throw new Error("usePortalAuth outside PortalAuthProvider");
  return ctx;
}
